export const enum ButtonType {
    Solid = "solid",
    Outline = "outline",
}
